export const useValidateData = (excludedFiles: string[] = [], hasHtml: string[] = [], booleanFields: string[] = []) => {
  interface IMappedDataItem {
    fieldName: string;
    value: unknown;
  }
  const validateData = (data: object) => {
    const emptyItems: string[] = [];
    const mappedData = mapData(data);
    mappedData.forEach((item) => setEmptyItem(item, emptyItems));

    return emptyItems;
  };

  const mapData = (data: object): IMappedDataItem[] => {
    const typedData = data as Record<string, unknown>;
    const mappedData = Object.keys(typedData).map((key) => {
      return {
        fieldName: key,
        value:
          typeof typedData[key] === 'string'
            ? hasHtml.indexOf(key) === -1
              ? typedData[key]
              : (typedData[key] as string).replaceAll(/<(.|\n)*?>/g, '')
            : typedData[key],
      };
    });

    return excludedFiles.length
      ? mappedData.filter((item: IMappedDataItem) => !excludedFiles.includes(item.fieldName))
      : mappedData;
  };

  const setEmptyItem = (item: IMappedDataItem, storeArray: string[]) => {
    // For boolean fields where false is valid, only null/undefined is considered empty
    if (booleanFields.includes(item.fieldName)) {
      if (item.value === null || item.value === undefined) {
        storeArray.push(item.fieldName);
      }
      return;
    }

    if (!item.value) {
      storeArray.push(item.fieldName);
    }

    if (Array.isArray(item.value) && !item.value.length) {
      storeArray.push(item.fieldName);
    }
  };

  const clearValidationFields = (validateDataArr: string[], shouldClearValidation: boolean) => {
    if (!shouldClearValidation) {
      return;
    }
    ['documentTitle'].forEach((item) => {
      const itemIndex = validateDataArr.indexOf(item);

      if (itemIndex < -1) {
        validateDataArr.splice(itemIndex, 1);
      }
    });
  };

  return {
    validateData,
    clearValidationFields,
  };
};
